export interface ReportNavViewModel {
  title: string;
  href: string;
  hidden?: boolean;
  disabled?: boolean;
  colorClass?: string;
  children?: ReportNavViewModel[];
}
